var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingReq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.832 62.125C11.832 50.6881 21.1035 41.4167 32.5404 41.4167C34.5964 41.4167 36.5823 41.7163 38.457 42.2743M59.1654 53.25H41.4154M44.3737 20.7083C44.3737 27.2437 39.0756 32.5417 32.5404 32.5417C26.005 32.5417 20.707 27.2437 20.707 20.7083C20.707 14.173 26.005 8.875 32.5404 8.875C39.0756 8.875 44.3737 14.173 44.3737 20.7083Z",
    stroke: "#3B82F6",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingReq);
export default __webpack_public_path__ + "static/media/pendingReq.ee28bf89490dd41641d3185cfbf09b7d.svg";
export { ForwardRef as ReactComponent };